import React from 'react';
import c from 'classnames';

import { SearchPagination } from '@uncinc/react-searchkit';

import Icon from '../../Icon';

export interface SearchForumCategoryPostsPaginationProps {
  className?: string;
}

const SearchForumCategoryPostsPagination: React.FC<
SearchForumCategoryPostsPaginationProps
> = (props) => {
  const { className } = props;

  const classNames = c('SearchForumCategoryPosts__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination
        pageRangeDisplayed={3}
        previousLabel={(
          <Icon icon="chevron" orientation="left" />
        )}
        nextLabel={(
          <Icon icon="chevron" />
        )}
      />
    </div>
  );
};

export default SearchForumCategoryPostsPagination;
